import { object } from 'yup'
import { FormSchema } from '../Wizard/Form/Types'
import { seoWords } from './shared/seoWords'
import { topic } from './shared/topic'
import { brandVoiceId, tone } from './shared/voiceTones'
import { sourceMaterialIds } from './shared/sourceMaterials'
import { language } from './shared/language'
import { brandKitId } from './shared/brandKitId'

const meta = {
  steps: ['Context', 'Generate'],
  submitLabel: 'Generate',
}

const fields = {
  topic,
  language,
  seo_words: seoWords.meta({ label: 'What keywords should be included?' }),
  brand_voice_id: brandVoiceId,
  source_material_ids: sourceMaterialIds,
  brand_kit_id: brandKitId,
  tone,
}

export const BaseSchema = object(fields).meta(meta) as FormSchema
